<template>
    <v-form-element :id="id" :display-label="false" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper">
        <div class="text-gray-500 font-thin flex">
            <div class="flex items-center" v-if="toggleStyle">
                <div class="pr-2">
                    <input class="tgl tgl-light" :id="id" type="checkbox" v-model="model" :required="required" />
                    <label class="tgl-btn" :for="id"></label>
                </div>
                <v-label :class-name="$spa.css.form.horizontal_label" :id="id" :label="getLabel()" :helper="helper"></v-label>
            </div>
            <div class="flex items-center md:pt-4" v-else>
                <input type="checkbox" :id="id" v-model="model" :required="required" />
                <div class="pl-2">
                    <v-label :class-name="$spa.css.form.horizontal_label" :id="id" :label="getLabel()" :helper="helper"></v-label>
                </div>
            </div>
        </div>
    </v-form-element>
</template>

<style scoped>
    .tgl {
    display: none;
    }
    .tgl, .tgl:after, .tgl:before, .tgl *, .tgl *:after, .tgl *:before, .tgl + .tgl-btn {
    box-sizing: border-box;
    }
    .tgl::-moz-selection, .tgl:after::-moz-selection, .tgl:before::-moz-selection, .tgl *::-moz-selection, .tgl *:after::-moz-selection, .tgl *:before::-moz-selection, .tgl + .tgl-btn::-moz-selection {
    background: none;
    }
    .tgl::selection, .tgl:after::selection, .tgl:before::selection, .tgl *::selection, .tgl *:after::selection, .tgl *:before::selection, .tgl + .tgl-btn::selection {
    background: none;
    }
    .tgl + .tgl-btn {
    outline: 0;
    display: block;
    width: 3em;
    height: 1.5em;
    position: relative;
    cursor: pointer;
    -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
    }
    .tgl + .tgl-btn:after, .tgl + .tgl-btn:before {
    position: relative;
    display: block;
    content: "";
    width: 50%;
    height: 100%;
    }
    .tgl + .tgl-btn:after {
    left: 0;
    }
    .tgl + .tgl-btn:before {
    display: none;
    }
    .tgl:checked + .tgl-btn:after {
    left: 50%;
    }

    .tgl-light + .tgl-btn {
    background: #f0f0f0;
    border-radius: 2em;
    padding: 2px;
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;
    }
    .tgl-light + .tgl-btn:after {
    border-radius: 50%;
    background: #fff;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    }
    .tgl-light:checked + .tgl-btn {
    background: #33bb58;
    }
</style>

<script>

    import FormElement from './Element';
    import Label from './Label';
    import mixin from './mixin';

    export default {
        components: {
            'v-label': Label,
            'v-form-element': FormElement
        },
        props: {
            toggleStyle: {
                type: Boolean,
                default: true
            }
        },
        mixins: [mixin]
    }
</script>
